import {Topic} from './topicFormContent';

export const SupportServiceTopic = Topic;
